import Modal from '@/components/ui/modals';
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/buttons';
import { Spinner } from '@/components/ui/forms';

function DeleteModal({
  title,
  message,
  isOpen,
  onClose,
  onDelete,
  isDeleting,
}) {
  const t = useTranslations('common');

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} maxWidth='max-w-lg'>
      <div className='px-4 py-8 text-center'>
        <p className='font-semibold'>{message}</p>

        <div className='mt-6 flex justify-center gap-4'>
          <Button className='w-48' onClick={onDelete} disabled={isDeleting}>
            {t('delete_key')}
            {isDeleting && <Spinner />}
          </Button>
          <Button
            onClick={onClose}
            disabled={isDeleting}
            className='!text-primary border-border border-2 bg-transparent px-18'
          >
            {t('cancel_key')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default DeleteModal;
